import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DownloadEverything from './components/DownloadEverything'
import RunClientsWithLogging from './components/RunClientsWithLogging'
import RunClientsWithDx9 from './components/RunClientsWithDx9'
import ShouldMinimizeToTray from './components/ShouldMinimizeToTray'
import LanguageSelection from './components/LanguageSelection'
import TestServers from './components/TestServers'
import LaunchDelay from './components/LaunchDelay'
import AutoLaunchOnLogin from './components/AutoLaunchOnLogin'
import AutoLaunchOnStartup from './components/AutoLaunchOnStartup'
import Layout from './components/Layout'
import ForgetAll from './components/ForgetAll'
import SharedCache from './components/SharedCache'
import ManageApi from './components/ManageApi'
import Status from './components/Status'
import styles from '../../styles.scss'

class SettingsView extends Component {
    componentWillUnmount() {
        this.props.clearCounter()
    }

    renderLanguagePicker = () => {
        if (this.props.hideLanguagePicker) return null

        return (
            <li>
                <LanguageSelection />
            </li>
        )
    }

    renderLayoutOptions = () => {
        if (this.props.hideLanguagePicker) return null

        return [<h2>{this.props.headers.layout}</h2>, <Layout />]
    }

    render() {
        return (
            <section className={styles.section}>
                <div className={styles.wrap}>
                    <div>
                        <h2>{this.props.headers.general}</h2>
                        <ul className={styles.settingList}>
                            <li>
                                <DownloadEverything />
                            </li>
                            <li>
                                <RunClientsWithLogging />
                            </li>
                            <li>
                                <RunClientsWithDx9 />
                            </li>
                            <li>
                                <ShouldMinimizeToTray />
                            </li>
                            {this.renderLanguagePicker()}
                            <li>
                                <h4>{this.props.headers.reset}</h4>
                                <ForgetAll />
                                <SharedCache />
                                <ManageApi />
                            </li>
                        </ul>
                    </div>
                    <div>
                        <TestServers />
                        <h2>{this.props.headers.launchOptions}</h2>
                        <ul className={styles.settingList}>
                            <li>
                                <AutoLaunchOnLogin />
                            </li>
                            <li>
                                <AutoLaunchOnStartup />
                            </li>
                            <li>
                                <LaunchDelay />
                            </li>
                        </ul>

                        {this.renderLayoutOptions()}
                    </div>
                </div>
                <Status />
            </section>
        )
    }
}

SettingsView.propTypes = {
    headers: PropTypes.shape({
        general: PropTypes.string,
        reset: PropTypes.string,
        launchOptions: PropTypes.string,
        layout: PropTypes.string,
    }),
    hideLanguagePicker: PropTypes.bool,
    clearCounter: PropTypes.func,
}

export default SettingsView



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/component.js